import { render, staticRenderFns } from "./PersonalNumber.vue?vue&type=template&id=efc577a6&scoped=true&"
import script from "./PersonalNumber.vue?vue&type=script&lang=js&"
export * from "./PersonalNumber.vue?vue&type=script&lang=js&"
import style0 from "./PersonalNumber.vue?vue&type=style&index=0&id=efc577a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc577a6",
  null
  
)

export default component.exports